import type { BugsTranslation } from "./en.bugs";

const bugsRu: BugsTranslation = {
  severity: {
    s1: "S1 Критичный",
    s2: "S2 Серьёзный",
    s3: "S3 Незначительный",
    s4: "S4 Косметический",
    short: { s1: "S1", s2: "S2", s3: "S3", s4: "S4" },
    rubric: {
      s1: "Не работает основной сценарий, потеря данных, влияние на деньги или безопасность, много пользователей.",
      s2: "Важная функция сломана и нет разумного обхода, или затронуто много пользователей.",
      s3: "Функция работает хуже, есть обходной путь, или затронуто мало пользователей.",
      s4: "Косметика: текст, вёрстка, мелкие UX-недочёты.",
    },
  },
  bugPriority: { p0: "P0", p1: "P1", p2: "P2", p3: "P3" },
  bugStatus: {
    reported: "Сообщено",
    triaged: "Разобрано",
    investigating: "Расследуется",
    mitigated: "Смягчено",
    fixed: "Исправлено",
    verified: "Проверено",
    analysis: "Анализ",
    closed: "Закрыто",
  },
  resolution: {
    fixed: "Исправлено",
    duplicate: "Дубликат",
    not_a_bug: "Не баг",
    wont_fix: "Не будем исправлять",
  },
  detectedBy: {
    customer: "Сообщил клиент",
    support: "Поддержка",
    internal: "Внутренний пользователь",
    monitoring: "Мониторинг / алерт",
    qa: "QA",
  },
  rootCause: {
    requirements_misunderstood: "Требования поняты неверно / неоднозначная спецификация",
    missing_requirement: "Упущено требование / не учтён граничный случай",
    logic_error: "Логическая ошибка в коде",
    integration: "Интеграция / сторонний сервис / контракт API",
    data: "Проблема с данными (плохие данные, миграция)",
    configuration: "Конфигурация / деплой / окружение",
    performance: "Производительность / масштабирование",
    security: "Безопасность",
    regression: "Регрессия (работало раньше, сломалось после изменения)",
    infrastructure: "Инфраструктура / хостинг",
    other: "Другое",
  },
  escapePoint: {
    requirements: "Требования / груминг",
    design_review: "Дизайн / техническое ревью",
    code_review: "Код-ревью",
    test_cases_missing: "Тест-кейсы — ни один кейс это не покрывал",
    test_execution_missed: "Тестирование — кейс был, но проблему пропустили",
    environment_difference: "Тестовое окружение отличалось от продакшена",
    monitoring: "Мониторинг — узнали только от клиентов",
    not_preventable: "Разумно предотвратить было нельзя",
  },
  actionKind: {
    regression_test: "Регрессионный тест",
    code_fix: "Исправление кода",
    monitoring: "Мониторинг / алерт",
    process: "Процесс / чек-лист",
    documentation: "Документация",
    training: "Обучение",
  },
  actionStatus: {
    open: "Открыто",
    in_progress: "В работе",
    done: "Готово",
    cancelled: "Отменено",
  },
  postmortemStatus: {
    none: "Не начат",
    draft: "Черновик",
    approved: "Утверждён",
  },
  linkKind: {
    related: "Связан",
    recurrence: "Повторение",
  },
  bugNav: {
    bugs: "Баги",
    regression: "Регрессионный набор",
    learnings: "Уроки",
    openMajor: "Открытых S1/S2: {{count}}",
  },
  bugs: {
    overdue: "Просрочено на {{time}}",
    dueIn: "Устранить за {{time}}",
    title: "Баги в продакшене",
    showMajor: "Только S1/S2",
    majorCallout: "Открытых S1/S2: {{count}} — это число на значке «Баги». Их чинить в первую очередь.",
    report: "Сообщить о баге",
    search: "Поиск багов",
    filterOpen: "Открытые",
    filterAll: "Все",
    filterClosed: "Закрытые",
    filterSeverity: "Серьёзность",
    filterStatus: "Статус",
    anyComponent: "Любой компонент",
    anyApp: "Любое приложение",
    mine: "Мои",
    empty: "Багов в продакшене нет",
    emptyBody: "Если что-то сломалось после релиза, сообщите здесь — баг будет отслеживаться по серьёзности и разобран.",
    noMatch: "Нет багов по этим фильтрам.",
    openActions: "Открытых действий: {{count}}",
    detected: "Обнаружен {{time}}",
    unowned: "Без ответственного",
    bugN: "BUG-{{n}}",
  },
  report: {
    more: "Подробнее",
    moreHint: "Приоритет, описание, влияние, время, компонент, ответственный. Всё это можно заполнить позже на странице бага.",
    sectionDetails: "Подробности",
    title: "Сообщить о баге в продакшене",
    intro: "Опишите, что произошло. Серьёзность — это влияние; приоритет — порядок исправления.",
    bugTitle: "Что не так?",
    titleRequired: "Опишите проблему одной строкой.",
    titlePlaceholder: "Возвраты по картам больше 1 000,00 падают с «Gateway error 502»",
    similarTitle: "Похожие прошлые баги — это дубликат или повторение?",
    severity: "Серьёзность",
    priority: "Приоритет",
    priorityAuto: "По умолчанию из серьёзности ({{p}}). Меняйте только с причиной.",
    detectedBy: "Кто обнаружил",
    component: "Компонент",
    componentPlaceholder: "напр. Возвраты",
    client: "Клиент",
    clientPlaceholder: "Имя пользователя",
    app: "Приложение",
    foundIn: "Найден в",
    description: "Описание",
    steps: "Шаги воспроизведения",
    stepsHint: "Enter добавляет следующий шаг; Enter на пустом шаге завершает список.",
    attachments: "Скриншоты, видео или файлы",
    attachmentsHint: "Изображения, видео, PDF, текст, CSV, JSON или ZIP, до 100 МБ каждый. Скриншот можно вставить (Ctrl/⌘ V).",
    uploading: "Загрузка {{done}}/{{total}}…",
    uploadFailed: "Не удалось загрузить {{name}}. Прикрепите его снова на странице бага.",
    unsupportedFile: "{{name}}: такой тип файла нельзя прикрепить (изображения, видео, PDF, текст, CSV, JSON или ZIP).",
    expected: "Ожидаемое поведение",
    actual: "Фактическое поведение",
    impact: "Влияние",
    startedAt: "Началось (примерно)",
    detectedAt: "Обнаружено",
    originTask: "Внесено задачей",
    originHint: "Задача, релиз которой это вызвал, напр. PAY-482.",
    owner: "Ответственный",
    submit: "Сообщить о баге",
    created: "BUG-{{n}} создан",
    sectionWhat: "Что произошло",
    sectionWhen: "Когда и где",
  },
  impact: {
    title: "Влияние",
    users: "Затронуто пользователей",
    customers: "Затронуто клиентов",
    money: "Финансовое влияние",
    moneyPlaceholder: "около 1 200 000 сум возвращено вручную",
    data: "Влияние на данные",
    workaround: "Обходной путь",
    none: "Влияние ещё не указано.",
  },
  bug: {
    stepOf: "Шаг {{n}} из {{total}}",
    nextStep: "далее: {{status}}",
    liveUpdate: "{{name}} обновил(а) этот баг — данные обновлены.",
    moveTo: "Перевести в «{{status}}»",
    skipTo: "Перейти к…",
    reopen: "Переоткрыть",
    reopenTitle: "Переоткрыть BUG-{{n}}?",
    reopenBody: "Баг вернётся в «Расследуется». Укажите причину, чтобы история была понятной.",
    reopenNote: "Почему баг переоткрывается?",
    close: "Закрыть",
    regressionCase: "Добавить регрессионный кейс",
    regressionCreated: "Регрессионный кейс {{key}} добавлен в регрессионный набор",
    regressionLink: "Регрессионный кейс {{key}}",
    statusChanged: "Статус: {{status}}",
    saved: "Сохранено",
    closedAs: "Закрыт · {{resolution}}",
    duplicateOf: "Дубликат BUG-{{n}}",
    details: "Подробности",
    noDetails: "Подробностей пока нет.",
    editDetails: "Изменить подробности",
    properties: "Свойства",
    reporter: "Автор",
    owner: "Ответственный",
    originTask: "Внесено задачей",
    openTask: "Открыть задачу в Mixla",
    noValue: "—",
    activity: "История",
    noActivity: "Пока ничего не происходило.",
    breadcrumb: "Баги",
  },
  close: {
    title: "Закрыть BUG-{{n}}",
    resolution: "Резолюция",
    duplicateOf: "Номер бага-оригинала",
    note: "Комментарий",
    noteRequired: "Для этой резолюции нужна причина.",
    blockersTitle: "Перед закрытием как «Исправлено»:",
    submit: "Закрыть баг",
    closed: "Баг закрыт",
    managersOnly: "Закрывать баги могут только менеджеры проекта.",
  },
  timeline: {
    edit: "Изменить время",
    done: "Готово",
    title: "Хронология",
    started: "Началось",
    detected: "Обнаружено",
    acknowledged: "Принято в работу",
    mitigated: "Смягчено",
    fixed: "Исправлено",
    verified: "Проверено",
    toDetect: "до обнаружения",
    toAcknowledge: "до реакции",
    toMitigate: "до смягчения",
    toFix: "до исправления",
    hint: "Время ставится при смене статуса. Если оно неточное, поправьте здесь.",
  },
  rca: {
    title: "Анализ первопричины",
    folded: "Не начат. Откройте, когда причина станет известна.",
    blameless: "Без поиска виноватых — спрашиваем, что это допустило, а не кто.",
    category: "Категория первопричины",
    escape: "Где должны были поймать?",
    choose: "Выберите…",
    rootCause: "Первопричина",
    whys: "5 почему",
    whyN: "Почему {{n}}",
    root: "Корень",
    addWhy: "Добавить «почему»",
    lesson: "Извлечённый урок",
    lessonHint: "Только если есть вывод, который стоит сохранить. Показывается в библиотеке уроков.",
  },
  postmortem: {
    title: "Постмортем",
    folded: "Не начат. Напишите, когда баг исправлен.",
    required: "Для S1/S2 обязателен перед закрытием бага.",
    summary: "Кратко",
    timeline: "Хронология",
    trigger: "Триггер",
    wentWell: "Что прошло хорошо",
    wentWrong: "Что пошло не так",
    lucky: "Где нам повезло",
    approve: "Утвердить",
    approved: "Постмортем утверждён",
    approvedBy: "Утвердил(а) {{name}}",
    editResets: "Если сохранить изменения, утверждённый постмортем вернётся в черновик.",
  },
  actions: {
    title: "Действия",
    empty: "Действий пока нет. Каждый серьёзный баг должен дать хотя бы одно.",
    newTitle: "Что мы сделаем?",
    kind: "Тип",
    owner: "Ответственный",
    due: "Срок",
    status: "Статус",
    add: "Добавить",
    added: "Действие добавлено",
    remove: "Удалить действие",
    overdue: "Просрочено",
    bug: "Баг",
  },
  comments: {
    feedTitle: "Обсуждение и история",
    title: "Комментарии",
    empty: "Комментариев пока нет.",
    placeholder: "Напишите комментарий…",
    send: "Отправить",
  },
  attachmentsBug: {
    title: "Вложения",
    removed: "Вложение удалено",
    uploaded: "Файл прикреплён",
  },
  links: {
    title: "Связанные баги",
    empty: "Связанных багов нет.",
    number: "Номер бага",
    add: "Связать",
    remove: "Убрать связь с BUG-{{n}}",
  },
  learnings: {
    title: "Уроки",
    tabLibrary: "Библиотека",
    tabReview: "Обзор",
    intro: "Закрытые баги и выводы из них. Поищите здесь, прежде чем делать что-то рискованное.",
    search: "Поиск уроков",
    anyCategory: "Любая первопричина",
    anyEscape: "Любая точка пропуска",
    empty: "Уроков пока нет. Они появляются, когда баги закрываются с выводом.",
    recurrences: "Повторялся: {{count}}",
    closedOn: "Закрыт {{time}}",
  },
  review: {
    intro: "Для ежемесячного разбора багов: что открыто, что просрочено, что ещё не проанализировано.",
    openBySeverity: "Открытые баги по серьёзности",
    recentMajor: "S1/S2 за последние 30 дней",
    recentMajorEmpty: "За последние 30 дней багов S1/S2 не было.",
    missingAnalysis: "Без анализа",
    missingAnalysisEmpty: "У каждого исправленного бага есть первопричина.",
    openActions: "Открытые действия",
    openActionsEmpty: "Открытых действий нет.",
  },
  regression: {
    title: "Регрессионный набор",
    intro: "Кейсы, которые не дают багам вернуться. Проходите их как обычную задачу — раундами и в режиме прохождения.",
    emptyTitle: "Регрессионного набора пока нет",
    emptyBody: "Он создаётся автоматически, когда первый баг получает регрессионный кейс, или его можно создать сейчас.",
    create: "Создать регрессионный набор",
  },
  components: {
    title: "Компоненты",
    intro: "Части продукта, к которым относят баги, напр. Возвраты, Оплата, Отчёты.",
    add: "Добавить компонент",
    placeholder: "Новый компонент",
    rename: "Переименовать «{{name}}»",
    remove: "Удалить «{{name}}»",
    empty: "Компонентов пока нет.",
    saved: "Компоненты сохранены",
  },
  closeCheck: {
    title: "Чтобы закрыть как исправленный:",
    verified: "Исправление проверено",
    rootCause: "Первопричина",
    escape: "Где должны были поймать",
    postmortem: "Постмортем утверждён",
    ready: "Можно закрывать",
  },
  sightings: {
    title: "Где замечен",
    empty: "Наблюдений пока нет. Добавьте, когда кто-то увидит этот баг на какой-либо версии.",
    seenAgain: "Замечен снова",
    record: "Записать наблюдение",
    addAnother: "Добавить ещё",
    version: "Версия",
    versionPlaceholder: "Найдите или введите версию",
    versionTextPlaceholder: "Введите версию",
    versionsFailed: "Не удалось загрузить версии приложения. Версию всё равно можно ввести.",
    useText: "Использовать текст «{{text}}»",
    useTextHint: "Версия не будет создана",
    linksTo: "Будет связано с версией {{name}}.",
    keptAsText: "Сохранится как текст. Свяжется само, когда у приложения появится версия с таким именем.",
    keptAsTextNoApp: "Сохранится как текст. Сможет связаться, когда в проекте появится приложение с такой версией.",
    liveHint: "Оставьте пустым, чтобы взять версию, работавшую в тот момент.",
    chooseApp: "Выберите приложение",
    noAppChosen: "Неизвестно",
    noApp: "Без приложения",
    noApps: "В этом проекте пока нет приложений, поэтому версию можно сохранить только как текст.",
    addApp: "Добавить приложение",
    noAppsAsk: "В этом проекте пока нет приложений, поэтому версию можно сохранить только как текст. Добавить приложение может менеджер проекта.",
    introducedIn: "Появился в",
    versionUnknown: "Версия неизвестна",
    inferred: "Определена автоматически: работала в тот момент",
    textOnly: "Только текст",
    migrated: "Из старых полей",
    reportedAs: "Указано как {{text}}",
    onFixVersion: "Баг открыт, но в этой версии есть его исправление.",
    setApp: "Указать приложение",
    makeVersion: "Создать версию {{name}}",
    outcome: {
      nothing: "",
      expected: "Ожидаемо",
      no_fix_here: "В этом приложении исправления пока нет",
      cant_compare: "Сравнить нельзя, проверьте вручную",
      evidence: "Добавлено к флагу",
      flagged: "Флаг поднят",
    },
    result: {
      nothing: "Наблюдение записано.",
      expected: "Ожидаемо: эта версия вышла раньше исправления.",
      no_fix_here: "Наблюдение записано. В этом приложении исправления пока нет.",
      cant_compare: "Наблюдение записано. Эту версию нельзя сравнить с исправлением, проверьте вручную.",
      evidence: "В этой версии должно быть исправление. Добавлено как свидетельство к флагу регрессии.",
      flagged: "Поднят флаг регрессии: в этой версии должно быть исправление. Ответственный, автор и менеджеры проекта уведомлены.",
    },
    inferredResult: "Связано с {{name}}, версией, работавшей в тот момент.",
    textResult: "«{{text}}» хранится как текст, пока не появится версия с таким именем.",
    bannerTitle: "Возможная регрессия в {{app}}.",
    bannerBody: "Замечен на {{version}}, где должно быть исправление из {{fix}}.",
    bannerEvidence: "Последующих наблюдений: {{count}}.",
    reopen: "Открыть снова",
    dismiss: "Отклонить",
    reopened: "Баг открыт снова",
    dismissed: "Флаг отклонён",
    reopenTitle: "Открыть снова для {{app}}",
    reopenBody: "Баг вернётся в статус «Расследуется». Это решит открытые флаги для {{apps}}, а исправления в этих приложениях перестанут учитываться.",
    dismissTitle: "Отклонить флаг для {{app}}",
    dismissBody: "Баг останется как есть. Новые наблюдения на этой версии только добавят свидетельства, а более высокая версия поднимет новый флаг.",
    note: "Примечание",
    noteRequired: "Укажите, почему баг открывается снова.",
    pastFlags: "Прошлые флаги",
    flagState: {
      open: "{{app}}: открыт",
      reopened: "{{app}}: открыт снова, {{name}}.",
      dismissed: "{{app}}: отклонён, {{name}}.",
    },
    dismissedUntil: "Действует, пока не появится версия выше {{version}}.",
  },
  bugActivity: {
    kinds: {
      bug_reported: "сообщил(а) о баге",
      bug_updated: "изменил(а) баг",
      bug_status_changed: "сменил(а) статус",
      bug_release_changed: "изменил(а) версии с исправлением",
      bug_closed: "закрыл(а) баг",
      bug_reopened: "переоткрыл(а) баг",
      postmortem_approved: "утвердил(а) постмортем",
      link_added: "связал(а) баг",
      link_removed: "убрал(а) связь",
      action_item_added: "добавил(а) действие",
      action_item_updated: "обновил(а) действие",
      action_item_removed: "удалил(а) действие",
      comment_added: "прокомментировал(а)",
      regression_case_created: "добавил(а) регрессионный кейс",
      attachment_added: "прикрепил(а) файл",
      attachment_removed: "удалил(а) файл",
      sighting_added: "записал(а) появление бага",
      sighting_linked: "связал(а) появления бага с версией",
      sighting_app_set: "указал(а) приложение для появления бага",
      regression_flagged: "отметил(а) регрессию",
      regression_reopened: "переоткрыл(а) регрессию",
      regression_dismissed: "отклонил(а) регрессию",
      regression_cleared: "снял(а) регрессию, которая больше не актуальна",
      gitlab_link_added: "связал(а) merge request или ветку",
      gitlab_link_confirmed: "подтвердил(а) связь с merge request или веткой",
      gitlab_link_removed: "удалил(а) связь с merge request или веткой",
      gitlab_fix_skipped_no_owner: "не удалось отметить баг исправленным при слиянии: у него нет владельца",
    },
  },
  inboxBugs: {
    title: "Мои баги",
    empty: "На вас нет открытых багов.",
  },
};

export default bugsRu;
